import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home' //首页
import login from '@/view/login' //登录页面
import opportunity from '@/view/opporTunity/opportunity'  //机经
import teacherteams from '@/view/teacherTeam/teacherteams'  //教师团队
import excellentcourse from '@/view/excellentCourse/excellentcourse' // 精品课程
import onOne from '@/view/excellentCourse/onOne' // 一对一
import questionbank from '@/view/questionBank/questionbank'   //仿真模考
import questionStock from '@/view/questionBank/questionStock'  //题库
import allsubjectcontent from '@/view/allSubjectContent/allsubjectcontent' //练习记录
import springClass from '@/view/excellentCourse/sprintClass'   //全程冲刺班
import onlinePractice from '@/view/questionBank/onlinePractice'  //在线练习
import searchMatter from '@/view/questionBank/searchMatter'  //搜索
import scheduleMatter from '@/view/questionBank/scheduleMatter'  //模考结果页面
import errSummary from '@/view/questionBank/errSummary'  //情况总结
import accountSettings from '@/view/accountSetting/accountSettings'  //账号安全
import libraryContent from '@/view/questionBank/libraryContent'  //题库内容
import libraryContentTwo from '@/view/questionBank/libraryContentTwo'  //题库内容-2
import openClass from '@/view/teacherTeam/openClass'  //公开课
import subscribe from '@/view/teacherTeam/subscribe'  //预约
import aboutGmat from '@/view/opporTunity/aboutGmat' //关于
import feedback from '@/view/questionBank/feedback' //反馈
import hightScore from '@/view/opporTunity/hightScore'
import mostData from '@/view/opporTunity/mostData.vue'
import introduce from '@/view/opporTunity/introduce'
import introduction from '@/view/opporTunity/about/introduction' //入门介绍
import matsList from '@/view/opporTunity/about/matsList' //数学列表
import logicalList from '@/view/opporTunity/about/logicalList' //逻辑列表
import grammarList from '@/view/opporTunity/about/grammarList' //语法列表
import readList from '@/view/opporTunity/about/readList' //阅读列表
import sbujectGuide from '@/view/opporTunity/sbujectGuide'
import number from '@/view/accountSetting/number'
import personalInfos from '@/view/accountSetting/personalInfos'
import examinContent from '@/view/examinatSystem/examinContent'
import examinatStart from '@/view/examinatSystem/examinatStart' //模考系统开始
import examInstructions from '@/view/examinatSystem/testExplanation/examInstructions' //模考系统说明
import systemRead from '@/view/examinatSystem/systemRead'   //模考阅读
import singleChoice from '@/view/examinatSystem/singleChoice'  //模考单选
import doubleChoice from '@/view/examinatSystem/doubleChoice'  //模考双选
import singleChoiceBoolean from '@/view/examinatSystem/singleChoiceBoolean'  //模考单选 => 判断
import down from '@/view/opporTunity/saomang/down.vue'  //全部几经 收费下载
import freeDown from '@/view/opporTunity/saomang/freeDown.vue'  //全部几经 免费下载
import saomang from '@/view/opporTunity/saomang/saomang.vue'  //全部几经 扫盲
import tongji from '@/view/opporTunity/saomang/tongji.vue'  //全部几经 统计
import grammar from '@/view/opporTunity/about/grammar.vue'  //GMAT 语法
import logic from '@/view/opporTunity/about/logic.vue'  //GMAT 逻辑
import ready from '@/view/opporTunity/about/ready.vue'  //GMAT 阅读
import shareInfos from '@/view/opporTunity/shareInfos'  //分享详情
import founding from '@/view/founding/founding.vue'  //创始之声
import imageAnalysis from '@/view/examinatSystem/imageAnalysis'  //图像分析
import table from '@/view/examinatSystem/table'  //表格题
import reasoning from '@/view/examinatSystem/reasoning'  //多源推理题

import forref from '@/view/forref/forref.vue'  //联系我们
import learntest from '@/view/learntest/learntest.vue'  //加入备考群

import explain from '@/view/examinatSystem/explain'  //模考双选

import resttime from '@/view/examinatSystem/resttime'  //休息时间
import test from '@/view/test/test.vue'  //测试页面
import selection from '@/view/examinatSystem/selection.vue'  //新题型
import review from '@/view/review/review.vue'  //检查题目
import choice from '@/view/examinatSystem/choice.vue'  //富文本多选题



Vue.use(Router)


export default new Router({
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/home', component: home },
    { path: '/test', component: test },
    { path: '/login', component: login },
    { path: '/opportunity', component: opportunity },
    { path: '/teacherteams', component: teacherteams },
    { path: '/excellentcourse', component: excellentcourse },
    { path: '/questionbank', component: questionbank },
    { path: '/questionStock', component: questionStock },
    { path: '/allsubjectcontent', component: allsubjectcontent },
    { path: '/springClass', component: springClass },
    { path: '/onlinePractice', component: onlinePractice },
    { path: '/errSummary/:id', component: errSummary },
    { path: '/libraryContent/:id', component: libraryContent },
    { path: '/libraryContentTwo', component: libraryContentTwo },
    { path: '/openClass/:skip', component: openClass },
    { path: '/feedback', component: feedback },
    { path: '/onOne', component: onOne },
    { path: '/searchMatter', component: searchMatter },
    { path: '/scheduleMatter', component: scheduleMatter },
    { path: '/exerciseResult', component: () => import('@/view/questionBank/exerciseResult') },
    { path: '/subscribe/:id/:name/:idx', component: subscribe },



    { path: '/founding', component: founding },
    { path: '/forref', component: forref },
    { path: '/learntest', component: learntest },


    { path: '/teacherteams', component: teacherteams },


    {
      path: '/accountSettings',
      component: accountSettings,
      redirect: 'number',
      children: [
        { path: '/number', component: number },
        { path: '/personalInfos', component: personalInfos },
      ]
    },
    {
      path: '/aboutGmat',
      component: aboutGmat,
      redirect: '/hightScore',
      children: [
        { path: '/hightScore', component: hightScore },
        { path: '/introduce', component: introduce },
        { path: '/introduction', component: introduction },
        { path: '/matsList', component: matsList },
        { path: '/logicalList', component: logicalList },
        { path: '/grammarList', component: grammarList },
        { path: '/readList', component: readList },
        { path: '/sbujectGuide', component: sbujectGuide },
        { path: '/grammar', component: grammar },
        { path: '/logic', component: logic },
        { path: '/ready', component: ready },
        { path: '/mostData', component: mostData },
        { path: '/shareInfos/:id', component: shareInfos },
      ],
    },
    {
      path: '/opportunity',
      component: opportunity,
      redirect: '/saomang',
      children: [
        { path: '/saomang', component: saomang },
        { path: '/tongji', component: tongji },
        { path: '/freeDown', component: freeDown },
        { path: '/down', component: down }
      ],
    },
    {
      path: '/examinContent',
      component: examinContent,
      redirect: '/examinContent/examinatStart',
      children: [
        { path: 'examinatStart/:id?', component: examinatStart },
        {
          path: 'examInstructions', component: examInstructions, children: [
            {
              path: '2',
              component: () => import('../view/examinatSystem/testExplanation/examInstructions')
            }
          ]
        },
        { path: 'systemRead', component: systemRead },
        { path: '/review', component: review },
        { path: '/singleChoice', component: singleChoice },
        { path: '/explain', component: explain },
        { path: '/doubleChoice', component: doubleChoice },
        { path: '/choice', component: choice },
        { path: '/singleChoiceBoolean', component: singleChoiceBoolean },
        { path: '/imageAnalysis', component: imageAnalysis },
        { path: '/table', component: table },
        { path: '/reasoning', component: reasoning },
        { path: '/selection', component: selection },
        { path: '/completion', component: () => import('../view/examinatSystem/completion') }
      ],
    },
    {
      path: '/examinContent',
      component: examinContent,
      redirect: '/examinContent/examinatStart',
      children: [
        { path: 'examinatStart/:id?', component: examinatStart },
        {
          path: 'examInstructions', component: examInstructions, children: [
            {
              path: '2',
              component: () => import('../view/examinatSystem/testExplanation/examInstructions')
            }
          ]
        },
        { path: 'systemRead', component: systemRead },
        { path: '/review', component: review },
        { path: '/singleChoice', component: singleChoice },
        { path: '/resttime', component: resttime },
        { path: '/imageAnalysis', component: imageAnalysis },
        { path: '/table', component: table },
        { path: '/reasoning', component: reasoning },
        { path: '/doubleChoice', component: doubleChoice },
        { path: '/choice', component: choice },


        
        { path: '/singleChoiceBoolean', component: singleChoiceBoolean },
        { path: '/completion', component: () => import('../view/examinatSystem/completion') }
      ],
    },
    {

      path: '/calendar',
      component: () => import('../view/calendar/index')
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js